<template>
  <div class="count-down">
    <a-button type="link" :disabled="(!!timer)||disabled" @click.native="countDown">{{ timer ?countNum+'秒': msg }}</a-button>
  </div>
</template>
<script>
export default {
  props: {
    count: {
      type: Number,
      default: 60
    },
    api: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      startd: false,
      msg: '发送验证码',
      countNum: this.count,
      timer: 0,
      disabled: false
    }
  },
  methods: {
    next() {
      this.timer = setInterval(() => {
        this.countNum--
        if (!this.countNum) {
          clearInterval(this.timer)
          this.timer = 0
          this.countNum = this.count
        }
      }, 1000)
    },
    countDown() {
      if (!this.timer) {
        this.$emit('start', this)
      }
    }
  }
}
</script>
<style lang="scss">
.count-down{
    width: auto;
    position: relative;
    left: 12px;
}
</style>
